import type { SVGProps } from 'react'

const Globe02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.22302 9C2.07706 9.64322 2 10.3126 2 11C2 11.6874 2.07706 12.3568 2.22302 13H6.1624C6.06859 12.3472 6.01408 11.6863 6.00022 11.0208C5.99993 11.0069 5.99993 10.9931 6.00022 10.9792C6.01408 10.3137 6.06859 9.65281 6.1624 9H2.22302ZM2.93552 7H6.57918C7.0384 5.32882 7.76219 3.73806 8.72571 2.28983C6.18481 2.95142 4.08079 4.69544 2.93552 7ZM11 2.5508C9.96032 3.89027 9.17195 5.39792 8.66439 7H13.3356C12.828 5.39792 12.0397 3.89027 11 2.5508ZM13.8141 9H8.18588C8.07773 9.65814 8.01525 10.3263 8.00023 11C8.01525 11.6737 8.07773 12.3419 8.18588 13H13.8141C13.9223 12.3419 13.9848 11.6737 13.9998 11C13.9848 10.3263 13.9223 9.65814 13.8141 9ZM15.8376 13C15.9314 12.3472 15.9859 11.6863 15.9998 11.0208C16.0001 11.0069 16.0001 10.9931 15.9998 10.9792C15.9859 10.3137 15.9314 9.65281 15.8376 9H19.777C19.9229 9.64322 20 10.3126 20 11C20 11.6874 19.9229 12.3568 19.777 13H15.8376ZM13.3356 15H8.66439C9.17195 16.6021 9.96032 18.1097 11 19.4492C12.0397 18.1097 12.828 16.6021 13.3356 15ZM8.72571 19.7102C7.76219 18.2619 7.0384 16.6712 6.57918 15H2.93552C4.08079 17.3046 6.18481 19.0486 8.72571 19.7102ZM13.2743 19.7102C14.2378 18.2619 14.9616 16.6712 15.4208 15H19.0645C17.9192 17.3046 15.8152 19.0486 13.2743 19.7102ZM19.0645 7H15.4208C14.9616 5.32882 14.2378 3.73806 13.2743 2.28983C15.8152 2.95142 17.9192 4.69544 19.0645 7ZM0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

export default Globe02
